import { useEffect } from 'react';
import { STATUS } from 'core/store';

import initAssignment from '../utils/init-assignment';

export default ({ assignment, id, root, setEditAssignment, statusGet }: any) => {
  useEffect(() => {
    if (!assignment || statusGet !== STATUS.SUCCESS) {
      return;
    }

    setEditAssignment({ ...initAssignment(id, root), ...assignment });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusGet, assignment]);
};
